module.exports = __webpack_public_path__ + "media/images/emblems/Iffwil-coat_of_arms-1edf9086bcf3739455b9b2e5ad649e12.svg";